const BREAK_MEDIUM = "992";
const $ = jQuery;

export default function menus() {

  createMobileBackButtons();

  if (window.innerWidth >= BREAK_MEDIUM) {
    subMenuSlider();
    desktopMenuUX();
  } else {
    mobileMenuUX();
  }

  $(window).resize(function(){
    resizeSlick();
    choosMenuUX();
  });

}

function desktopMenuUX() {
  // Hover Events for First Level of Nav
  $('.scrim').hide();
  $('.nav-primary .menu-item-has-children')
    .mouseenter(function(event) {
      var item = $(this);
      openMenuItem(item, false);
      $('.scrim').stop();
      $('.scrim').fadeIn();

    })
    .mouseleave(function() {
      var item = $(this);
      closeMenuItem(item, false);
      $('.scrim').stop();
      $('.scrim').fadeOut();
    });

  // Hover Event for Second Level of Nav
  $('.nav-primary .menu-item-has-children ul.sub-menu > li.menu-item-object-product_cat')
    .mouseenter(function(event) {
      var item = $(this);
      openMenuItem(item, true);

    })
    .mouseleave(function() {
      var item = $(this);
      closeMenuItem(item, true);
    });
}

function mobileMenuUX() {
  mobileSearch();

  $('#mobile-menu-toggle').click(function(event) {
    event.preventDefault();
    openMenu();
  });

  // Touch Events for first level of Nav
  $('.nav-primary .menu-item-has-children > a').on('click', function(event) {
    event.preventDefault();
    var parentLi = $(this).parent('.menu-item');
    openMenuItem(parentLi, false);
  });

  // Touch Events for Second level of Nav
  $('.nav-primary .menu-item-has-children ul.sub-menu > li.menu-item-object-product_cat > a').on('click', function(event) {
    event.preventDefault();
    var parentLi = $(this).parent('.menu-item');
    openMenuItem(parentLi, true);
  });
}

function createMobileBackButtons() {
  // Prepend Parent Element onto Child Mobile menu First Level
  var firstLevelItem = $('.nav-primary .menu-item-has-children');
  // Prepend Parent Element onto Child Mobile menu Second Level
  var secondLevelItem = $('.nav-primary .menu-item-has-children ul.sub-menu > li.menu-item-object-product_cat');
  createParentLinkBack(firstLevelItem, false);
  createParentLinkBack(secondLevelItem, true);
}

// Function to open menu item
// @param item - jquery object of parent element
// @param sub - if submenu parameter is passed do x
function openMenuItem( item, sub ) {
  if (sub == true) {
    $(item).children('.menu-item-content').addClass("expanded");
  } else {
    $(item).children('.sub-menu').addClass("expanded");
  }
}

function closeMenuItem( item, sub ) {
  if (sub == true) {
    $(item).children('.menu-item-content').removeClass("expanded");
  } else {
    $(item).children('.sub-menu').removeClass("expanded");
  }
}

function openMenu() {
  $('#nalgene-main-menu').addClass('expanded');
  $('.scrim').fadeIn();
  $('.scrim').click(function() {
    closeMenu();
  });
}

function closeMenu() {
  $('#nalgene-main-menu').removeClass('expanded');
  $('.sub-menu').removeClass('expanded');
  $('.scrim').fadeOut();
  $('.menu-item-has-children').removeClass('expanded');
}

function mobileSearch() {
  $('#mobile-search').click(function(event) {
    openMobileSearch();
  });
  $('#mobile-search-close').click(function(event) {
    closeMobileSearch();
  });
}

function openMobileSearch() {
  $('.site-search').addClass('expanded-mobile');
  $('.site-search').removeClass('hidden-mobile');
}

function closeMobileSearch() {
  $('.site-search').addClass('hidden-mobile');
  $('.site-search').removeClass('expanded-mobile');
}

function createParentLinkBack( menuItem, sub ) {
  menuItem.each(function() {
    var menuItem = this;
    var title = $(this).children('a').html();
    var submenu = sub ? $(this).find('.menu') : $(this).children('.sub-menu');
    var submenuTitleItem =
      $(`<li class="menu-item submenu-title-item"><a href="#">${title}</a></li>`);
    submenuTitleItem.on('click', function(event) {
      event.preventDefault();
      closeMenuItem(menuItem, sub);
    });
    submenu.prepend(submenuTitleItem);
  });
}

function subMenuSlider() {
  $('.slick-menu-featured').not('.slick-initialized').slick({
    dots: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4
  });

  $('.slick-menu').not('.slick-initialized').slick({
    dots: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5
  });
}

function resizeSlick() {
    if ( window.innerWidth >= BREAK_MEDIUM) {
      subMenuSlider();
    } else {
      $('.slick-menu-featured.slick-initialized').slick('unslick');
      $('.slick-menu.slick-initialized').slick('unslick');
    }
}

function choosMenuUX() {
    if ( window.innerWidth >= BREAK_MEDIUM) {
      desktopMenuUX();
    } else {
      mobileMenuUX();
    }
}
